import { Link } from 'react-router-dom';

import { TMarkdownLinkProps } from '@/shared/components/ui/markdown-link/markdown-link.types';

export const MarkdownLink = ({ href, children }: TMarkdownLinkProps) => {
  if (!href) {
    return <>{children}</>;
  }

  const isInternalLink =
    href.startsWith(window.location.origin) || href.startsWith('/');

  if (isInternalLink) {
    const path = href.replace(window.location.origin, '');
    return <Link to={path}>{children}</Link>;
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};
